/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online ruler shown at actual size. Calibrate it to your screen once, then measure in centimetres, millimetres or inches — on desktop or along your phone's edge.`)
};

const es_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regla online gratuita mostrada a tamaño real. Calíbrala una vez a tu pantalla y mide en centímetros, milímetros o pulgadas, en el escritorio o a lo largo del borde de tu móvil.`)
};

const de_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses Online-Lineal in Originalgröße. Einmal auf deinen Bildschirm kalibrieren und dann in Zentimetern, Millimetern oder Zoll messen — am Desktop oder entlang der Kante deines Smartphones.`)
};

const nl_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online liniaal op ware grootte. Kalibreer hem eenmalig op je scherm en meet daarna in centimeters, millimeters of inches — op desktop of langs de rand van je telefoon.`)
};

const fr_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règle en ligne gratuite affichée en taille réelle. Calibrez-la une fois pour votre écran, puis mesurez en centimètres, millimètres ou pouces — sur ordinateur ou le long du bord de votre téléphone.`)
};

const it_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Righello online gratuito mostrato a grandezza reale. Calibralo una volta sul tuo schermo, poi misura in centimetri, millimetri o pollici — su desktop o lungo il bordo del telefono.`)
};

const pt_br2_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua online gratuita exibida em tamanho real. Calibre-a uma vez para sua tela e depois meça em centímetros, milímetros ou polegadas — no computador ou na borda do celular.`)
};

const pt_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Régua online gratuita mostrada em tamanho real. Calibre-a uma vez para o seu ecrã e depois meça em centímetros, milímetros ou polegadas — no computador ou ao longo da extremidade do telemóvel.`)
};

const ja_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実物大で表示される無料オンライン定規。画面に合わせて一度校正すれば、センチメートル、ミリメートル、インチで測定できます — デスクトップでもスマートフォンの端でも。`)
};

const zh_ruler_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线标尺，按真实尺寸显示。只需校准一次屏幕，即可用厘米、毫米或英寸测量——适用于电脑或手机边缘。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ruler_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ruler_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ruler_meta_description", locale)
	if (locale === "en") return en_ruler_meta_description(inputs)
	if (locale === "es") return es_ruler_meta_description(inputs)
	if (locale === "de") return de_ruler_meta_description(inputs)
	if (locale === "nl") return nl_ruler_meta_description(inputs)
	if (locale === "fr") return fr_ruler_meta_description(inputs)
	if (locale === "it") return it_ruler_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ruler_meta_description(inputs)
	if (locale === "pt") return pt_ruler_meta_description(inputs)
	if (locale === "ja") return ja_ruler_meta_description(inputs)
	return zh_ruler_meta_description(inputs)
};